import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import Link from "../../quarks/Link";
import LabelAtm from "../LabelAtm";
export var StyledImageWithTextLinkAtm = styled(Link).withConfig({
  componentId: "sc-17ikyjf-0"
})(function (_ref) {
  var $label = _ref.$label,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  var borderStyle = "".concat(unit(1), " solid ").concat(getBorderColor(theme, $onColor, "extraLow"));
  var paddingSize = "".concat(space(0.5), " ").concat(space(1));
  return css(["display:inline-flex;position:relative;align-items:center;padding:", ";border-radius:", ";background:", ";text-decoration:none;cursor:pointer;img{margin-right:", ";}&:hover{box-shadow:", ";}", " ", "{padding:", ";border:", ";}", "{padding:", ";}"], paddingSize, unit(5), getColor(theme, "backgroundLight"), space(1.5), getBoxShadow(theme, "nano"), $label && css(["border:", ";"], borderStyle), breakpoint("small", "huge"), paddingSize, borderStyle, breakpoint("huge"), space(1));
});
export var StyledLabelAtm = styled(LabelAtm).withConfig({
  componentId: "sc-17ikyjf-1"
})(["margin-left:", ";", "{position:absolute;top:", ";right:", ";}"], space(1.5), breakpoint("small", "medium"), space(-2), space(1));